import { BASELINE_REWARD_SETTINGS_ENUM } from "../enums/baseline-reward-settings.enum";

export const BASE_REWARD_SETTINGS = [
  {
    label: BASELINE_REWARD_SETTINGS_ENUM.LOCATION,
    value: 'LOCATION'
  },
  {
    label: BASELINE_REWARD_SETTINGS_ENUM.OWNER,
    value: 'OWNER'
  }
]
